import { createDirectStore, } from 'direct-vuex';
import Vue from 'vue';
import Vuex from 'vuex';
import { isDate, isObject, } from '~/utils/models/isObject';
import { initialiseStoreValue, } from '~/utils/store';
import alertModule from '~/utils/store/alert-module';
import globalConfigModule from '~/utils/store/global-config-module';

Vue.use(Vuex);

const UserDetailsStorageKey = 'userDetails';
const UserPaymentDetailsStorageKey = 'userPaymentDetails';

interface UserDetails {
	customerLastName: string;
	customerEmail: string;
	customerNumber: number;
	customerRefNumber: string;
}

interface UserPaymentDetails {
	accountBalance: number;
	amountDue: number;
	currentDueDate: Date;
	paymentMethod: string;
}

function isUserDetails(input: unknown): input is UserDetails {
	return (
		true &&
		isObject(input) &&
		typeof input.customerLastName === 'string' &&
		typeof input.customerEmail === 'string' &&
		typeof input.customerNumber === 'number' &&
		typeof input.customerRefNumber === 'string' &&
		true
	);
}

function isUserPaymentDetails(input: unknown): input is UserPaymentDetails {
	return (
		true &&
		isObject(input) &&
		typeof input.accountBalance === 'number' &&
		typeof input.amountDue === 'number' &&
		isDate(input.currentDueDate) &&
		true
	);
}

function initialiseUserDetails(): UserDetails {
	return initialiseStoreValue(
		UserDetailsStorageKey,
		isUserDetails,
		() => ({
			customerEmail: '',
			customerLastName: '',
			customerNumber: 0,
			customerRefNumber: '',
		})
	);
}

function initialiseUserPaymentDetails() {
	return initialiseStoreValue(
		UserPaymentDetailsStorageKey,
		isUserPaymentDetails,
		() => undefined,
		(userInput) => {
			// eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
			userInput.currentDueDate = new Date(userInput.currentDueDate);
			// eslint-disable-next-line @typescript-eslint/no-unsafe-return
			return userInput;
		},
	);
}

const {
	store,
} = createDirectStore({
	state: {
		showSpinner: false,
		userDetails: initialiseUserDetails(),
		userPaymentDetails: initialiseUserPaymentDetails(),
		currentStep: null as (number | null),
	},
	getters: {
		hasExistingUserDetails(state) {
			return (state.userDetails.customerEmail &&
				state.userDetails.customerLastName &&
				(state.userDetails.customerNumber != null) &&
				(state.userDetails.customerRefNumber != null)) === true;
		},
		hasExistingUserPaymentDetails(state) {
			return state.userPaymentDetails !== undefined;
		},
	},
	mutations: {
		showSpinner(state) {
			state.showSpinner = true;
		},
		hideSpinner(state) {
			state.showSpinner = false;
		},
		setStep(state, step: number | null) {
			state.currentStep = step;
		},
		updateUserDetails(state, userDetails: UserDetails) {
			sessionStorage.setItem(UserDetailsStorageKey, JSON.stringify(userDetails));
			state.userDetails = userDetails;
		},
		updateUserPaymentDetails(state, userPaymentDetails: UserPaymentDetails) {
			sessionStorage.setItem(UserPaymentDetailsStorageKey, JSON.stringify(userPaymentDetails));
			state.userPaymentDetails = userPaymentDetails;
		},
		reset(state) {
			sessionStorage.removeItem(UserDetailsStorageKey);
			sessionStorage.removeItem(UserPaymentDetailsStorageKey);
			state.userDetails = initialiseUserDetails();
			state.userPaymentDetails = initialiseUserPaymentDetails();
		},
	},
	modules: {
		alertModule,
		globalConfigModule,
	},
});

export const Store = store;
